var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('img',{attrs:{"alt":"Vue logo","src":require("../../assets/img/logo.png")}}),_c('button',{on:{"click":_vm.getData}},[_vm._v("getData from Server ")])])}
var staticRenderFns = []

export { render, staticRenderFns }